import React from 'react';
import { selectColor } from '@panel/commons/core/theme';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { ContainerProgressBar, BarFilled } from './styles';

const ProgressBar = ({
  fillValue,
  filledColor,
  emptyColor,
  dataPanel,
  hoverColor,
  tooltipComponent,
  totalOnlinePostings,
  hoverActive
}) => {
  const setPosition = fill => {
    if (fill && fill <= 50) return 'top-start';
    if (fill && fill > 50 && fill < 85) return 'top-center';
    if (fill && fill >= 85) return 'top-end';
    return 'top-start';
  };

  const progressBarWithTooltip = () => {
    return totalOnlinePostings && totalOnlinePostings >= 0 ? (
      <SimpleTooltip
        offset={20}
        backgroundColor={selectColor('black')}
        text={tooltipComponent}
        position={setPosition(fillValue)}
        dataPanel={`progressBar-tooltip-${dataPanel}`}
        allowPlacements='top-end'
        autoPlacements
        delayOut={0}
      >
        <BarFilled
          fill={fillValue}
          filledColor={filledColor}
          hoverColor={hoverColor}
          data-panel={`progressBar-filled-${dataPanel}`}
          active={hoverActive}
        />
      </SimpleTooltip>
    ) : (
      <BarFilled
        fill={fillValue}
        filledColor={filledColor}
        hoverColor={hoverColor}
        data-panel={`progressBar-filled-${dataPanel}`}
      />
    );
  };

  return (
    <ContainerProgressBar
      emptyColor={emptyColor}
      data-panel={`progressBar-base-${dataPanel}`}
      hoverColor={hoverColor}
      active={hoverActive}
    >
      {!tooltipComponent ? (
        <BarFilled
          fill={fillValue}
          filledColor={filledColor}
          hoverColor={hoverColor}
          data-panel={`progressBar-filled-${dataPanel}`}
        />
      ) : (
        progressBarWithTooltip()
      )}
    </ContainerProgressBar>
  );
};

export default ProgressBar;
